import { SingularNoun } from '../../types'

const наебалово: SingularNoun = {
  type: 'singular noun',
  nominativeSingular: 'наебалово',
  genitiveSingular: 'наебалова',
  dativeSingular: 'наебалову',
  accusativeSingular: 'наебалово',
  instrumentalSingular: 'наебаловом',
  prepositionalSingular: 'наебалове',
}

export default наебалово
